import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog/Dialog';
import FlatButton from 'material-ui/FlatButton';
import compose from 'recompose/compose';
import languagesHelper from 'helpers/languages';
import styled, { keyframes } from 'styled-components';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import translator from 'components/hoc/translator';
import utils from 'helpers/utils';
import { RefreshIcon, TranslateIcon } from 'assets/materialIcons/materialIcons';

const rotate = keyframes`
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
`;

const LoadingRefreshIcon = styled(RefreshIcon)`
    animation: ${ rotate } 1.5s linear;
`;

class TranslateButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            showDialog: false,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (utils.diffObjects(nextProps, this.props) || utils.diffObjects(nextState, this.state)) {
            return true;
        }

        return false;
    }

    handleOpenDialog = () => {
        this.setState({
            showDialog: true,
        });
    }

    handleCloseDialog = () => {
        this.setState({
            showDialog: false,
        });
    }

    handleAcceptChanges = () => {
        const {
            handleTranslation,
            sourceLanguage,
            sourceText,
            targetLanguage,
            name,
        } = this.props;

        handleTranslation(sourceLanguage, targetLanguage, sourceText, name);

        this.handleCloseDialog();
    }

    showDialogContent() {
        const {
            sourceLanguage,
            sourceText,
            targetLanguage,
            translate,
        } = this.props;

        if (!sourceText) {
            return (
                <div>
                    <p>
                        { translate('forms.localisation.update.inactive', {
                            locale: languagesHelper.getLabel(sourceLanguage),
                        }) }
                    </p>
                </div>
            );
        }

        return (
            <div>
                <div>
                    <p>
                        { translate('forms.localisation.update.description', {
                            locale: languagesHelper.getLabel(sourceLanguage),
                            target: languagesHelper.getLabel(targetLanguage),
                        }) }
                    </p>

                    <p>
                        <strong>
                            { translate('forms.localisation.update.description_2', {
                                locale: languagesHelper.getLabel(sourceLanguage),
                                target: languagesHelper.getLabel(targetLanguage),
                            }) }
                        </strong>
                        <span>&nbsp;</span>

                        { translate('forms.localisation.update.description_3', {
                            locale: languagesHelper.getLabel(sourceLanguage),
                            target: languagesHelper.getLabel(targetLanguage),
                        }) }
                    </p>
                </div>
            </div>
        );
    }

    render() {
        const {
            sourceLanguage,
            sourceText,
            translate,
        } = this.props;

        const {
            loading,
            showDialog,
        } = this.state;

        let actions = [
            <FlatButton
                keyboardFocused={ true }
                key='cancel'
                label={ translate('actions.cancel') }
                onTouchTap={ this.handleCloseDialog }
                primary={ true }
            />,
            <FlatButton
                key='ok'
                label={ translate('actions.ok') }
                onTouchTap={ this.handleAcceptChanges }
                primary={ true }
            />,
        ];

        if (!sourceText) {
            actions = [
                <FlatButton
                    key='ok'
                    label={ translate('actions.ok') }
                    onTouchTap={ this.handleCloseDialog }
                    primary={ true }
                />,
            ];
        }

        return (
            <span>
                <FlatButton
                    disabled={ loading }
                    icon={ loading ?
                        <LoadingRefreshIcon color={ theme.palette.primary1Color } /> :
                        <TranslateIcon color={ theme.palette.primary1Color } />
                    }
                    labelPosition='after'
                    onTouchTap={ this.handleOpenDialog }
                    primary={ true }
                    style={ {
                        borderRadius: '0 0 0 5px',
                    } }
                    tabIndex={ -1 }
                />

                <Dialog
                    title={ translate('forms.localisation.origin.title', {
                        source: languagesHelper.getLabel(sourceLanguage),
                    }) }
                    actions={ actions }
                    modal={ false }
                    open={ showDialog }
                    overlayStyle={ {
                        backgroundColor: 'rgba(237, 236, 236, 0.6)',
                    } }
                    autoScrollBodyContent={ true }
                    onRequestClose={ this.handleCloseDialog }
                >
                    { this.showDialogContent() }
                </Dialog>
            </span>
        );
    }
}

TranslateButton.propTypes = {
    handleTranslation: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    sourceLanguage: PropTypes.string.isRequired,
    sourceText: PropTypes.string,
    targetLanguage: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    translate,
    translator,
);

export default enhance(TranslateButton);



// WEBPACK FOOTER //
// ./src/components/form/localisation/translations/TranslateButton.js